export default "__VITE_ASSET__MuMMc2ot__"